import styled from 'styled-components';

export default styled.section`
  padding: 3rem ${props => props.theme.padding.inner} 6.0625rem;

  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    padding: 5rem ${props => props.theme.padding.inner} 2.125rem;
  }

  .inner {
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.container};
    }

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transform: translateY(10px);
        transition: all 0.4s ease-in-out;
      }
    }

    .active& {
      opacity: 1;
      transform: none;
    }
  }

  .categories {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;
    list-style: none;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      flex-direction: row;
      flex-wrap: wrap;
      align-items: stretch;
      justify-content: space-between;
    }
  }

  .category {
    padding: 0;
    margin: 1.875rem 0;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      margin: 0 0 7.125rem;
    }

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      width: calc(33% - 2.125rem);
    }

    header {
      border-bottom: solid 1px ${props => props.theme.colors.grey5};

      h2 {
        margin: 0 0 1rem;
      }

      a {
        color: ${props => props.theme.colors.claytonBlue};
        text-decoration: none;
        transition: all 0.4s ease-in-out;

        &:hover,
        &:focus,
        &:active {
          color: ${props => props.theme.colors.bigSky};
        }
      }
    }

    .faqs {
      margin: 0;
      padding: 1.25rem 0;
      list-style: none;
    }

    .faq {
      padding: 0;
      line-height: 1.25em;
      margin: 1rem 0;

      .type-caption {
        line-height: ${props => props.theme.lineHeights.caption.tight}
      }

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }

      a {
        text-decoration: none;
        transition: all 0.1s ease-in-out;

        &:hover,
        &:focus,
        &:active {
          color: ${props => props.theme.colors.claytonBlue};
          text-decoration: underline;
        }
      }
    }
  }
`;
